// @owners { team: patient-health }
import { createSelector } from 'reselect';
import { getMedicationsFromPrescriptions as getMedications } from '~shared/features/my-meds/selectors/getMedicationsFromPrescriptions';
import { type Medication } from '~shared/features/my-meds/types';

type SearchOptions = Record<string, Medication>;

export default createSelector([getMedications], (medications: Medication[]): SearchOptions => {
  const searchableMedications = medications.filter(
    (medication) => !medication.prescriptions.some((rx) => rx.is_add_on_otc),
  );
  return searchableMedications.reduce<Record<string, Medication>>((options, medication) => {
    medication.prescriptions.forEach((prescription) => {
      if (prescription.medication_name) {
        options[prescription.medication_name.toLowerCase()] = medication;
      }
      if (prescription.rx_number) {
        options[prescription.rx_number] = medication;
      }
      if (prescription.brands) {
        options[prescription.brands.toLowerCase()] = medication;
      }
    });

    return options;
  }, {});
});
